import moment from "moment";

import { IUsersTabModel } from "@/Administration/Models/UI/Users/IUsersTabModel";
import { UserEditMode } from "@/Administration/Models/UI/Users/UserEditMode";
import { UsersSubmenuEnum } from "@/Administration/Models/UI/Users/UsersSubmenuEnum";
import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { ClinicSettings } from "@/Common/Api/MedfarDictionaries/Dto/Responses/ClinicSettings";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DSQEmployeeComponent } from "@/Common/Components/DSQ/DSQEmployeeComponent";
import { MultifactorAuthenticationAdminDeactivationPopup } from "@/Common/Components/MultifactorAuthentication/MultifactorAuthenticationAdminDeactivationPopup";
import { PatientProfileImagePopup } from "@/Common/Components/Person/ProfileImagePopup";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { Guid } from "@/Common/Models/Guid";
import { AuthenticatorCodeDeliveryMethod } from "@/Common/Models/MultifactorAuthentication/AuthenticatorCodeDeliveryMethod";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { cacheStore } from "@/Globals/Stores/CacheStore";
import { UserTypeAssignmentPopup } from "./UserTypeAssignmentPopup";

import styles from "./EmployeeBannerComponent.module.scss";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IEmployeeBannerProps {
    transitionClass?: string;
    model: IUsersTabModel;
    clinicSettings: ClinicSettings;
}

class EmployeeBannerState {
    public employeeResult: EmployeeUIModel;
    public isProfileImagePopupOpen: boolean;
    public isDSQEmployeePopupOpen: boolean;
    public isUserTypeAssignmentPopupOpen: boolean;
    public isMultifactorAuthenticationDeactivationPopupOpen: boolean;
}

class EmployeeBannerComponent extends BaseReactComponent<IEmployeeBannerProps, EmployeeBannerState> {
    private c1ColorAlign: React.CSSProperties = { "backgroundColor": "#f4f6f9", "textAlign": "right" };
    private c1c2Color: React.CSSProperties = { "backgroundColor": "#f4f6f9" };
    private c2Style: React.CSSProperties = { "marginLeft": "10px", "width": "460px" };

    public constructor(props: IEmployeeBannerProps) {
        super(props);
        this.state = {
            employeeResult: props.model.get("SelectedEmployee").clone(),
            isProfileImagePopupOpen: false,
            isDSQEmployeePopupOpen: false,
            isUserTypeAssignmentPopupOpen: false,
            isMultifactorAuthenticationDeactivationPopupOpen: false
        };
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(nextProps: IEmployeeBannerProps): void {
        let currentResult = this.props.model.get("SelectedEmployee");
        let nextResult = nextProps.model.get("SelectedEmployee");

        if (currentResult !== nextResult) {
            this.mutateState(s => s.employeeResult = nextResult.clone());
        }
    }

    public render(): JSX.Element {
        const imageUrl = this.state.employeeResult.Model.ProfilePicture
            ? apiSettings.buildAppUrl(`api/patient/profile/image/fetch/${this.state.employeeResult.Model.ProfilePicture.Id}?_nocache=${this.props.model.get("SelectedEmployee").ProfileImageVersion}`, { auth: true, noCache: false })
            : img_p_banner_icon_100;

        let formattedPhone: string = "";
        if (this.state.employeeResult.Model.Phones && this.state.employeeResult.Model.Phones.length > 0)
            formattedPhone = PhoneNumber.stringFormattedPhone(this.state.employeeResult.Model.Phones[0], true);

        let type: string = "";
        const employeeType = this.state.employeeResult.Type;
        switch (employeeType) {
            case EmployeeType.Assistant: type = cacheStore.GetString("Enums_EmployeeType_Assistant"); break;
            case EmployeeType.Practician: type = cacheStore.GetString("Enums_EmployeeType_Practician"); break;
            case EmployeeType.Admin: type = cacheStore.GetString("Enums_EmployeeType_Admin"); break;
            case EmployeeType.Api: type = cacheStore.GetString("Enums_EmployeeType_Api"); break;
        }

        let isQcState = (cacheStore.GetDefaultRegionForActiveSite().LookupCode == cacheStore.FindLookupByLookupCode("CanadaState_QC").LookupCode);
        const employeeUIModel = this.state.employeeResult;
        const employeeModel = this.state.employeeResult.Model;
        let dsqEmployeeInfo = cacheStore.GetString("btnSynchroniserDSQ");
        if (employeeModel != null && employeeModel.LastNameDSQ != null && employeeModel.FirstNameDSQ != null && employeeModel.LicenceDSQ != null) {
            dsqEmployeeInfo = this.state.employeeResult.Model.LastNameDSQ + ", " + this.state.employeeResult.Model.FirstNameDSQ + " (" + this.state.employeeResult.Model.LicenceDSQ + ")";
        }

        let cssDSQSynchronizedIcon = " glyphicon-remove red-text";
        if (!IsNullOrWhiteSpace(employeeModel.FirstNameDSQ) || !IsNullOrWhiteSpace(employeeModel.LastNameDSQ) || !IsNullOrWhiteSpace(employeeModel.LicenceDSQ)) {
            cssDSQSynchronizedIcon = " glyphicon-ok green-text";
        }

        let canEdit = this.props.model.get("UserEditMode") == UserEditMode.Edit ||
            this.props.model.get("UserEditMode") == UserEditMode.View;

        const isApiUser = employeeType === EmployeeType.Api;

        const isSingleSignOnEnabled = cacheStore.ClinicSettings.EnableSSOAuthentication;

        // block deactivating MFA when editing yourself and mandatory MFA is enabled
        const canDeactivateMultifactorAuthentication = canEdit
            && this.state.employeeResult.Model.AuthenticatorEnabled
            && (
                this.state.employeeResult.Model.User_id !== sessionStore.userId
                || !cacheStore.ClinicSettings.EnableMandatoryMultifactorAuthentication
            )
            && !isApiUser;

        return (
            <div className="info-banner bottom-border">
                {this.state.isProfileImagePopupOpen && (
                    <PatientProfileImagePopup
                        localDispatchContext={this}
                        profilePictureModel={this.state.employeeResult.Model.ProfilePicture}
                        cancelCallbackFunction={() => this.onClosePictureClick()}
                        uploadCompleteCallbackFunction={path => this.onPictureUploaded(path)}
                        deletePicOperation={LocalOperations.AdministrationUsers.ProfilePictureDeleted}
                    />
                )}

                {this.state.isDSQEmployeePopupOpen && isQcState && (
                    <DSQEmployeeComponent
                        employeeModel={employeeModel}
                        onCloseCallback={() => this.mutateState(s => s.isDSQEmployeePopupOpen = false)}
                        updateEmployeeCallback={e => this.updateEmployee(e)}
                    />
                )}

                {this.state.isUserTypeAssignmentPopupOpen && (
                    <UserTypeAssignmentPopup
                        editedUser={employeeUIModel}
                        onCancel={() => this.mutateState(s => s.isUserTypeAssignmentPopupOpen = false)}
                        onContinue={employeeUIModel => this.saveUserType(employeeUIModel)}
                        showAccountType={true}
                        popupTitle={cacheStore.GetString("AccountTypeChangeLabel")}
                        popupMessage={cacheStore.GetString("UserTypeChangeLabel")}
                        clinicSettings={this.props.clinicSettings}
                    />
                )}

                {this.state.isMultifactorAuthenticationDeactivationPopupOpen && (
                    <MultifactorAuthenticationAdminDeactivationPopup
                        onCancel={() => this.mutateState(s => s.isMultifactorAuthenticationDeactivationPopupOpen = false)}
                        onConfirm={() => this.deactivateMultifactorAuthenticatorForCurrentEmployee()}
                    />
                )}

                <div className="photo">
                    <div className="pull-left">
                        <div className="pic-profile-wrp">
                            <img src={imageUrl} style={{ width: "180px", height: "180px", borderBottomLeftRadius: " 50%", borderBottomRightRadius: " 50%", borderTopLeftRadius: " 50%", borderTopRightRadius: " 50%" }} alt="" />
                        </div>
                        <div style={{ "textAlign": "center", "marginTop": "8px" }} onClick={() => this.mutateState(s => s.isProfileImagePopupOpen = true)}>
                            {(canEdit && !this.state.employeeResult.Model.IsInactive) &&
                                <a style={{ "textDecoration": "underline" }}>{cacheStore.GetString("ChangePictureLabel")} </a>
                            }
                        </div>
                    </div>
                </div>

                <div className="info" style={{ "paddingLeft": "10px" }}>
                    <div className="tb">
                        <div className="tbc left">
                            <table>
                                <tbody style={{ "marginLeft": "10px" }}>
                                    <tr>
                                        <td colSpan={2} className="c1" style={this.c1c2Color}>
                                            <strong>
                                                <h3 style={this.state.employeeResult.Model.IsInactive ? { "color": "red" } : {}}>
                                                    {Employee.getFullNameWithPrefixNameSuffixTitle(this.state.employeeResult.ContactFacetId)}
                                                </h3>
                                            </strong>
                                        </td>
                                        <td style={this.c1c2Color} />
                                        <td style={{ "backgroundColor": "#f4f6f9", "paddingLeft": "5px" }}>
                                            {this.state.employeeResult.Model.IsInactive && (
                                                <strong>
                                                    <h3 style={this.state.employeeResult.Model.IsInactive ? { "color": "red" } : {}}> {cacheStore.GetString("DeactivatedLabel")} </h3>
                                                </strong>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className="c1" style={this.c1c2Color}>
                                            <label className="form-label" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1ColorAlign}><label>{cacheStore.GetString("TypeLabel")}</label></td>
                                        <td className="c2" style={this.c1c2Color}>
                                            <div style={this.c2Style}>
                                                <strong>{MyleHelper.ReplaceEmptyString(type)}</strong>
                                            </div>
                                        </td>
                                        <td colSpan={2} style={this.c1c2Color}>
                                            {(canEdit && !this.state.employeeResult.Model.IsInactive && !isApiUser) && (
                                                <a
                                                    style={{ "textDecoration": "underline" }}
                                                    onClick={() => this.mutateState(s => s.isUserTypeAssignmentPopupOpen = true)}
                                                    data-cy="userProfile-userBannerModifyType"
                                                >
                                                    {cacheStore.GetString("ModifyLabel")}
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    {!isApiUser && (
                                        <>
                                            <tr>
                                                <td className="c1" style={this.c1ColorAlign}><label>{cacheStore.GetString("lblPhone")}</label></td>
                                                <td className="c2" style={this.c1c2Color}>
                                                    <div style={this.c2Style}>
                                                        <strong>{MyleHelper.ReplaceEmptyString(formattedPhone)}</strong>
                                                    </div>
                                                </td>
                                                <td colSpan={2} style={this.c1c2Color}>
                                                    {(canEdit && !this.state.employeeResult.Model.IsInactive) && (
                                                        <a
                                                            style={{ "textDecoration": "underline" }}
                                                            onClick={() => sessionStore.dispatch(
                                                                LocalOperations.AdministrationUsers.PhoneModify,
                                                                { selectedTab: UsersSubmenuEnum.Demography }
                                                            )}
                                                        >
                                                            {cacheStore.GetString("ModifyLabel")}
                                                        </a>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="c1" style={this.c1ColorAlign}><label>{cacheStore.GetString("EmailLabel")}</label></td>
                                                <td className="c2" style={this.c1c2Color}>
                                                    <div style={this.c2Style}>
                                                        <strong>{(this.state.employeeResult.Model.Emails && this.state.employeeResult.Model.Emails.length > 0) ? MyleHelper.ReplaceEmptyString(this.state.employeeResult.Model.Emails[0].Address) : "--"}</strong>
                                                    </div>
                                                </td>
                                                <td colSpan={2} style={this.c1c2Color}>
                                                    {canEdit && !this.state.employeeResult.Model.IsInactive && (
                                                        <a
                                                            style={{ "textDecoration": "underline" }}
                                                            onClick={() => sessionStore.dispatch(
                                                                LocalOperations.AdministrationUsers.EmailModify,
                                                                { selectedTab: UsersSubmenuEnum.Demography }
                                                            )}
                                                        >
                                                            {cacheStore.GetString("ModifyLabel")}
                                                        </a>
                                                    )}
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                    <tr>
                                        <td className="c1" style={this.c1ColorAlign}><label>{cacheStore.GetString("UserLabel")}</label></td>
                                        <td className="c2" style={this.c1c2Color}>
                                            <div style={this.c2Style}>
                                                <strong>{MyleHelper.ReplaceEmptyString(this.state.employeeResult.Model.UserName)}</strong>
                                            </div>
                                        </td>
                                        {!isSingleSignOnEnabled && (
                                            <td style={this.c1c2Color}>
                                                {(canEdit && !this.state.employeeResult.Model.IsInactive && !isApiUser) && (
                                                    <span>
                                                        <a style={{ "marginRight": "5px", "textDecoration": "underline" }} onClick={this.modifyPassword.bind(this, this.state.employeeResult.Model)}>{cacheStore.GetString("ChangePasswordLabel")}</a>
                                                        {" | "}
                                                    </span>
                                                )}
                                            </td>
                                        )}
                                        <td style={{ "backgroundColor": "#f4f6f9", ...(isSingleSignOnEnabled ? {} : { "paddingLeft": "5px" }) }}>
                                            {(canEdit && !this.state.employeeResult.Model.IsInactive && this.state.employeeResult.Model.HasPinSet && !isApiUser) && (
                                                <span>
                                                    <a style={{ "marginRight": "5px", "textDecoration": "underline" }} onClick={this.modifyPin.bind(this, this.state.employeeResult.Model)}>{cacheStore.GetString("ModifyPinLabel")}</a>
                                                    {" | "}
                                                </span>
                                            )}
                                            {canDeactivateMultifactorAuthentication && (
                                                <span>
                                                    <a className={styles.deactivateMFA} data-cy="user-deactivate-mfa" onClick={() => this.mutateState(s => s.isMultifactorAuthenticationDeactivationPopupOpen = true)}>{cacheStore.GetString("MultifactorAuthentication_DeactivateMultifactorAuthenticationLabel")}</a>
                                                    {" | "}
                                                </span>
                                            )}
                                            <div style={{ "backgroundColor": "#f4f6f9", ...(isSingleSignOnEnabled ? {} : { "paddingLeft": "5px" }), display: "inline" }}>
                                                {canEdit && (this.state.employeeResult.Model.IsInactive) && <a style={{ "color": "green", "textDecoration": "underline" }} onClick={this.onActivateUsers.bind(this, this.state.employeeResult.Model)}>{cacheStore.GetString("ReactivateLabel")}</a>}
                                                {canEdit && (!this.state.employeeResult.Model.IsInactive) && <a style={{ "color": "red", "textDecoration": "underline" }} onClick={this.onActivateUsers.bind(this, this.state.employeeResult.Model)}>{cacheStore.GetString("DeactivateUserLabel")}</a>}

                                            </div>
                                        </td>
                                    </tr>
                                    {!isApiUser && (
                                        <>
                                            <tr>
                                                <td className="c1" style={this.c1ColorAlign}><label>{cacheStore.GetString("LastConnectionDate")}</label></td>
                                                <td className="c2" style={this.c1c2Color}>
                                                    <div style={this.c2Style}>
                                                        <strong>{this.state.employeeResult.Model.LastConnection == null ? "--" : moment(this.state.employeeResult.Model.LastConnection).format("YYYY-MM-DD  hh:mm:ss")}</strong>
                                                    </div>
                                                </td>
                                                {isQcState && (
                                                    <td style={this.c1c2Color} colSpan={2}>
                                                        <span>
                                                            <span className={"glyphicon" + cssDSQSynchronizedIcon} />
                                                            <span style={{ marginLeft: "5px" }}>{cacheStore.GetString("DSQLabel")}</span>
                                                            <a style={{ "marginLeft": "5px", "textDecoration": "underline" }} onClick={() => this.mutateState(s => s.isDSQEmployeePopupOpen = true)}>{dsqEmployeeInfo}</a>
                                                        </span>
                                                    </td>
                                                )}
                                            </tr>
                                            <tr>
                                                <td className="c1" style={this.c1ColorAlign}><label>{cacheStore.GetString("ActivationDateLabel")}</label></td>
                                                <td className="c2" colSpan={3} style={this.c1c2Color}>
                                                    <div style={this.c2Style}>
                                                        <strong>{this.state.employeeResult.Model.DateActivated == null ? "--" : moment(this.state.employeeResult.Model.DateActivated).format("YYYY-MM-DD  hh:mm:ss")}</strong>
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private onClosePictureClick(): void {
        this.mutateState(s => { s.isProfileImagePopupOpen = false; });
    }

    private onPictureUploaded(pathSaved: string): void {
        sessionStore.dispatch(LocalOperations.AdministrationUsers.ProfilePictureUploaded, { path: pathSaved, employeeContactId: this.state.employeeResult.ContactId });

        this.onClosePictureClick();
    }

    private onActivateUsers(item: Employee): void {
        sessionStore.dispatch(LocalOperations.AdministrationUsers.InActivateUsers, { IsInActive: !item.IsInactive, contactId: item.Contact_id });
    }

    private modifyPassword(item: Employee): void {
        sessionStore.dispatch(LocalOperations.AdministrationUsers.PasswordModify, { EmployeeId: item.ContactFacet_id });
    }

    private modifyPin(item: Employee): void {
        sessionStore.dispatch(LocalOperations.AdministrationUsers.PinModify, { EmployeeId: item.ContactFacet_id });
    }

    private updateEmployee(selectedEmployee: Employee): void {
        // update selected employee
        this.mutateState(s => {
            s.employeeResult.Model.FirstNameDSQ = selectedEmployee.FirstNameDSQ;
            s.employeeResult.Model.LastNameDSQ = selectedEmployee.LastNameDSQ;
            s.employeeResult.Model.LicenceDSQ = selectedEmployee.LicenceDSQ;
            s.employeeResult.Model.LicenceRoot = selectedEmployee.LicenceRoot;
            s.employeeResult.Model.NUI = selectedEmployee.NUI;
            s.isDSQEmployeePopupOpen = false;
            s.isProfileImagePopupOpen = false;
            s.isUserTypeAssignmentPopupOpen = false;
        });

        // When the selected employee is the current user, update the current employee in the sessionStore.
        sessionStore.updateCurrentEmployee((e: Employee) => {
            e.FirstNameDSQ = selectedEmployee.FirstNameDSQ;
            e.LastNameDSQ = selectedEmployee.LastNameDSQ;
            e.LicenceDSQ = selectedEmployee.LicenceDSQ;
            e.LicenceRoot = selectedEmployee.LicenceRoot;
            e.NUI = selectedEmployee.NUI;
        });

        settingsStore.EmitChangeToListeners();
    }

    private saveUserType(employeeUIModel: EmployeeUIModel): void {
        sessionStore.dispatch(
            LocalOperations.AdministrationUsers.UserTypeModify,
            {
                EmployeeId: employeeUIModel.Model.ContactFacet_id,
                ContactId: employeeUIModel.Model.Contact_id,
                Type: employeeUIModel.Model.Type,
                LicenseOrganizationRuleId: Employee.getIssuingOrgRule(employeeUIModel.Model)?.Id,
                LicenseOrganizationSpecializationId: employeeUIModel.Model.LicenseOrganizationSpecializationId
            }
        );

        this.mutateState(s => s.isUserTypeAssignmentPopupOpen = false);
    }

    /**
     * Deactivate the multifactor authentication for the current employee.
     */
    private async deactivateMultifactorAuthenticatorForCurrentEmployee(): Promise<void> {
        const userId = this.state.employeeResult.Model.User_id;
        const employeeId = this.state.employeeResult.Model.ContactFacet_id;

        const response = cacheStore.ClinicSettings.EnableMultifactorAuthenticationModule
            ? await this.deactivateForUser(userId)
            : await this.deactivateForEmployee(employeeId);

        if (!response.isSuccess) {
            sessionStore.showPopup(response.errors);
        }
        else {
            this.mutateState(
                s => {
                    s.employeeResult.Model.AuthenticatorEnabled = false;
                    s.isMultifactorAuthenticationDeactivationPopupOpen = false;
                },
                () => {
                    if (cacheStore.GetCurrentEmployee().ContactFacet_id === employeeId) {
                        sessionStore.dispatch(LocalOperations.Settings.UpdateAuthenticatorCodeDeliveryMethod, { method: AuthenticatorCodeDeliveryMethod.NotSelected });
                    }
                }
            );
        }
    }

    private deactivateForUser(userId: string): Promise<ClientResponse> {
        return Client.postAsync(
            ServerOperations.Server.Myle_MultifactorAuthenticationModule_Admin_DeactivateForUser,
            {
                UserId: userId
            }
        );
    }

    /** @deprecated Use {@link deactivateForUser} insetad. */
    private deactivateForEmployee(employeeId: Guid): Promise<ClientResponse> {
        return Client.postAsync(
            ServerOperations.Server.Myle_MultifactorAuthenticator_DeactivateForEmployee,
            {
                EmployeeId: employeeId
            }
        );
    }
}

export { EmployeeBannerComponent };
